export default __webpack_public_path__ + "27e6ea3eda511b1d2d6913c2f9ca6237.png";